import "./corporate-profile.css";

import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import axios from "axios";

import {
  HabeebullahProfile,
  shariahMemberList,
  YounesProfile,
} from "constants/corporate-profile";
import BODButton from "./BODButton";
import useStore from "stores/Store";
import { isEmpty } from "lodash";

function ShariahBoard() {
  const [chairman, setChairman] = useState();
  const [deputyChairman, setDeputyChairman] = useState();
  const [members, setMembers] = useState();
  const { aboutState, setAboutState } = useStore();

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/abouts?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setAboutState(jsonResponse);
      setChairman(
        jsonResponse?.CorporateProfile[0]?.ShariahBoard[0]?.Chairman[0]
      );
      setDeputyChairman(
        jsonResponse?.CorporateProfile[0]?.ShariahBoard[0]?.DeputyChairman[0]
      );
      setMembers(jsonResponse?.CorporateProfile[0]?.ShariahBoard[0]?.Members);
      // setAboutData(jsonResponse);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (isEmpty(aboutState)) {
      fetchAboutData();
    } else {
      setChairman(
        aboutState?.CorporateProfile[0]?.ShariahBoard[0]?.Chairman[0]
      );
      setDeputyChairman(
        aboutState?.CorporateProfile[0]?.ShariahBoard[0]?.DeputyChairman[0]
      );
      setMembers(aboutState?.CorporateProfile[0]?.ShariahBoard[0]?.Members);
    }
  }, []);

  return (
    <>
      <div className="container bod-page">
        <h1>
          <span>Corporate</span> Profile
        </h1>

        <BODButton />
        <div style={{ height: "100px" }}></div>

        <Row className="d-flex align-items-center">
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
          <Col md={2} xs={4}>
            <h2 className="divider-title">Chairman</h2>
          </Col>
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
        </Row>
        <div style={{ height: "32px" }}></div>

        <Row className="justify-content-center">
          <Col md={6} xs={12} className="profile-card-mobile">
            <Row className="profile-card align-items-end">
              <Col md={6}>
                <img src={chairman?.image_link} alt="roger" width={"100%"} />
              </Col>
              <Col md={6}>
                <div className="content">
                  <h1>{chairman?.name}</h1>
                  <h2>{chairman?.position}</h2>
                  <div style={{ height: "16px" }}></div>
                  <p>
                    {chairman?.description.length < 260
                      ? parse(chairman?.description)
                      : parse(chairman?.description.substring(0, 260) + "...")}
                  </p>

                  <Link
                    to="/about/corporate-profile/view-profile"
                    state={{ profile: chairman }}
                  >
                    Read More
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div style={{ height: "80px" }}></div>
        <Row className="d-flex align-items-center">
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
          <Col md={2} xs={4}>
            <h2 className="divider-title">Deputy Chairman</h2>
          </Col>
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
        </Row>
        <div style={{ height: "32px" }}></div>

        <Row className="justify-content-center">
          <Col md={6} xs={12} className="profile-card-mobile">
            <Row className="profile-card align-items-end">
              <Col md={6}>
                <img
                  src={deputyChairman?.image_link}
                  alt="roger"
                  width={"100%"}
                />
              </Col>
              <Col md={6}>
                <div className="content">
                  <h1>{deputyChairman?.name}</h1>
                  <h2>{deputyChairman?.position}</h2>
                  <div style={{ height: "16px" }}></div>
                  <p>
                    {deputyChairman?.description.length < 260
                      ? parse(deputyChairman?.description)
                      : parse(
                          deputyChairman?.description.substring(0, 260) + "..."
                        )}
                  </p>

                  <Link
                    to="/about/corporate-profile/view-profile"
                    state={{ profile: deputyChairman }}
                  >
                    Read More
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div style={{ height: "80px" }}></div>

        <Row className="d-flex align-items-center">
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
          <Col md={2} xs={4}>
            <h2 className="divider-title">Members</h2>
          </Col>
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
        </Row>

        <div style={{ height: "32px" }}></div>
        <Row className="profile-card-row">
          {members?.map((item, index) => (
            <Col key={index} md={4} className="profile-card">
              <img src={item?.image_link} alt="roger" width={"100%"} />
              <div className="content-members mb-4">
                <h1>{item?.name}</h1>
                <h2>{item?.position}</h2>
                <div style={{ height: "16px" }}></div>
                {item?.description?.length < 120 ? (
                  <p>{parse(item?.description)}</p>
                ) : (
                  <p>{parse(item?.description?.substring(0, 120) + "...")}</p>
                )}

                <Link
                  to="/about/corporate-profile/view-profile"
                  state={{ profile: item }}
                >
                  Read More
                </Link>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default ShariahBoard;
